import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import {
  Col,
  Grid,
  Panel,
  Button,
  Breadcrumb,
  ButtonToolbar,
} from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import { Translate, I18n } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';

import Spinner from '../Widgets/spinner';
import ContentWrapper from '../Layout/ContentWrapper';
import { fetchPackers2, deletePacker } from '../../actions/settings_actions';
import PackerForm from '../../containers/General/packerForm';
import {isOLG, isGGI} from '../../actions/root_url'
import ConfirmActionModal from '../Common/confirmActionModal'

const propTypes = {
  value: PropTypes.node,
  checkPermission: PropTypes.func,
};

const defaultProps = {
  value: null,
  checkPermission: () => {},
};


class Packers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingPackers: false,
      isPackerModalOpen: false,
      deleteModalOpen: false,
      packersList: {
        rows: [],
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      selectedPackerIdx: null,
    };
  }

  componentDidMount() {
    this.handleFetchPackers();
  }

  componentDidUpdate(prevProps, prevState) {
  }
  
  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.selectedCompany !== this.props.selectedCompany) {
      this.handleFetchPackers();
    }
  }
  
  openPackerModal= () => {
    this.setState({ isPackerModalOpen: true });
  }
  closePackerModal = () => {
    this.setState({ isPackerModalOpen: false });
  }

  openDeleteModal= () => {
    this.setState({ deleteModalOpen: true });
  }

  closeDeleteModal = () => {
    this.setState({deleteModalOpen: false})
  }
  deleteCofirm = () => {
    this.handleDelete('force')
  }

  handleFetchPackers = (startDate, endDate) => {
    const handleSuccess = (packers) => {
      const { selectedPackerIdx } = this.state;
      if (selectedPackerIdx !== null) {
        map(packers, (row, index) => {
          if (index === selectedPackerIdx) {
            row.isSelected = true;
          }
        });
      }
    
      const packersList = { ...this.state.packersList, rows: packers };
      this.setState({
        packersList,
        isLoadingPackers: false,
      });
    };
    const handleFailure = () => {
      this.setState({ isLoadingPackers: false });
    };
    this.setState({ isLoadingPackers: true }, () => {
      const selectedCompany = this.props.selectedCompany;
      fetchPackers2(handleSuccess, handleFailure, selectedCompany.value);
    });
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentPacker();
    this.openPackerModal();
  }
  setCurrentPacker(e) {
    e.preventDefault();
    const currentPacker = this.state.packersList.selectedRows[0];
    this.props.selectPacker(currentPacker);
    this.openPackerModal();
  }
  handleDelete(force = '') {
    const success = () => {
      let packersList ={...this.state.packersList, selectedRows: []}
      this.setState({
        isLoadingPackers: false,
        packersList,
      }, () => {
        this.handleFetchPackers();
      })
    }
    const failed = () => {
      this.openDeleteModal();
    }
    const currentPacker = this.state.packersList.selectedRows[0];
    deletePacker(currentPacker.id, success, failed, force);
  }

  renderPackers = () => {
    if (this.state.isLoadingPackers) {
      return <Spinner />;
    }

    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.packersList);
      return rows;
    };

    const getSize = () => {
      const rowLength = getRows().length;
      return rowLength;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const packersList = { ...this.state.packersList, sortColumn, sortDirection };
      this.setState({ packersList });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      let deliveryHistoryRows;
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        deliveryHistoryRows = newRows[r.rowIdx].salesOrders;
        newRows[r.rowIdx].isSelected = true;
      });
      const packersList = {
        ...this.state.packersList,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      const deliveryHistory = {
        ...this.state.deliveryHistory,
        rows: deliveryHistoryRows,
      };
      this.setState({
        packersList,
        selectedPackerIdx: rows[0].rowIdx,
      });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.packersList.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const packersList = { ...this.state.packersList, filters: newFilters };
      this.setState({ packersList });
    };

    const onClearFilters = () => {
      const packersList = { ...this.state.packersList, filters: {} };
      this.setState({ packersList });
    };

    const columns = [
      {
        key: 'name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <Col sm={6}>
        <div id="Packers-dataGrid1">
          <ReactDataGrid
            rowKey="name"
            onGridSort={handleGridSort}
            columns={columns}
            rowHeight={25}
            rowGetter={rowGetter}
            toolbar={<Toolbar enableFilter />}
            onClearFilters={onClearFilters}
            onAddFilter={handleFilterChange}
            rowsCount={getSize()}
            minHeight={530}
            enableRowSelect="single"
            rowSelection={{
              showCheckbox: true,
              onRowsSelected,
              selectBy: {
                isSelectedKey: 'isSelected',
              },
            }}
          />
        </div>
      </Col>
    );
  }
  
  renderPackerAction = () => (
    <div>
      <ButtonToolbar>
        <Button
          bsStyle="primary"
          onClick={(event) => { this.clickNew(event) }}
        >
          <em className="fa fa-plus marginRightStyle"/><Translate value="create" />
        </Button>
        <Button
          bsStyle="primary"
          onClick={(event) => { this.setCurrentPacker(event) } }
          disabled={!this.state.packersList.selectedRows || this.state.packersList.selectedRows.length !== 1}
        >
          <em className="fa fa-edit marginRightStyle" /><Translate value="edit" />
        </Button>
        <Button
          bsStyle="danger"
          onClick={(event) => { this.handleDelete() } }
          disabled={!this.state.packersList.selectedRows || this.state.packersList.selectedRows.length !== 1}
        >
          <em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
        </Button>
      </ButtonToolbar>
    </div>
  )

  formTitle() {
    if (this.props.currentPacker) return <Translate value={(isOLG || isGGI) ? "edit_picker" : "edit_packer"} />;
    else return <Translate value={(isOLG || isGGI) ? "add_picker" : "add_packer"} />;
  }

  render() {
    const modalnDialog = {
      width: '300px',
      marginLeft: '-15%',
    };
    const deleteDialog = {
      width: '400px',
      marginLeft: '-15%',
      height: '300px'
    };
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="dispatch" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={(isOLG || isGGI)? "pickers" :"packers"} />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="packers">
          <Col xs={12}>
            <Panel className="table-panel">
              <h2><Translate value={(isOLG || isGGI) ? "pickers" : "packers"} /></h2>
              { this.renderPackerAction() }
              { this.renderPackers() }
            </Panel>
          </Col>
        </Grid>
        <SkyLightStateless
          dialogStyles={modalnDialog}
          isVisible={this.state.isPackerModalOpen}
          onCloseClicked={this.closePackerModal}
          title={this.formTitle()}
        >
          <PackerForm closePT={this.closePackerModal} />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={deleteDialog}
          isVisible={this.state.deleteModalOpen}
          onCloseClicked={this.closeDeleteModal}
        >
          <ConfirmActionModal
            case='delete_picker'
            closeC={this.closeDeleteModal}
            deletePickerConfirm={this.deleteCofirm}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

Packers.propTypes = propTypes;
Packers.defaultProps = defaultProps;

export default Packers;



// WEBPACK FOOTER //
// ./master/jsx/components/General/Packers.jsx